module.exports = __webpack_public_path__ + "static/media/football-ball.60acd605.svg";